import styled from 'styled-components';
import IcWalkinSummaryWaitingList from './IcWalkinSummaryWaitingList';
import IcAppointMentSummaryWaiting from './IcAppointMentSummaryWaiting';
import { IWaitingListResItem } from 'features/user/services/types/waiting';
import { ECheckInType } from 'features/checkIn/services/types/api';

type Props = {
  waitingList?: IWaitingListResItem[];
};

const SummaryWaitingList = ({ waitingList = [] }: Props) => {
  const walkingLength = waitingList.filter(item => item.checkInType === ECheckInType.WALK_IN).length;
  const appointmentLength = waitingList.filter(item => item.checkInType === ECheckInType.APPOINTMENT).length;

  return (
    <Container>
      <ItemContainer className='left'>
        <div className='wrapper'>
          <div className='number_icon'>
            <div className='label'>{walkingLength}</div>
            <IcWalkinSummaryWaitingList />
          </div>
          <div className='title'>WALK-IN</div>
        </div>
      </ItemContainer>
      <ItemContainer>
        <div className='wrapper'>
          <div className='number_icon'>
            <div className='label'>{appointmentLength}</div>
            <IcAppointMentSummaryWaiting />
          </div>
          <div className='title'>APPOINTMENT</div>
        </div>
      </ItemContainer>
    </Container>
  );
};

export default SummaryWaitingList;

const Container = styled.div`
  display: flex;
  gap: 16px;
  .left {
    padding-right: 16px;
    border-right: 1px solid #232f3e;
  }
`;

const ItemContainer = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 2px;
    .title {
      color: #505050;
      font-size: 14px;
      font-weight: 600;
      line-height: normal;
    }
  }
  .number_icon {
    display: flex;
    gap: 4px;
    align-items: center;
    .label {
      color: #1d2129;
      font-size: 32px;
      font-weight: 600;
      line-height: 32px;
    }
  }
`;
